
export default {
    productData: {
        serialNumber: 'DA-HMS-004',
        name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 4',
        construction: {
        composition: [
            {
            type: 'screed',
            title: { de: 'Estrich' },
            output: '18',
            value: 'd-18'
            },
            {
              type: 'insulation',
              title: { de: 'Holzfaserdämmplatte mit 24 Einfäsungen für Heizrohre' },
              output: '24',
              value: 'unkown-24'
              },
            {
            type: 'soundInsulation',
            title: { de: 'Schalldämmplatte' },
            output: '2 x 15 mm',
            value: 'si-30'
            },
            {
            type: 'insulation',
            title: { de: 'Holzfaserdämmplatte' },
            output: '≥ 20',
            value: 'w-20'
            },
            {
            type: 'fill',
            title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 132 kg/m<sup>2</sup>), Rieselschutz' },
            output: '≥ 80',
            value: 'scsb-80'
            },
            {
            type: 'woodenPanel',
            title: { de: 'Holzwerkstoffplatte HW' },
            output: '≥ 22',
            value: 22
            },
            {
            type: 'supportingStructure',
            title: { de: 'Balken' },
            output: '240',
            value: 'b-240'
            },
            {
                type: 'suspendedCeiling',
                title: { de: 'Hohlraumdämpfung' },
                output: '2 x 120',
                value: 'h-240'
              },
            {
            type: 'suspendedCeiling',
            title: { de: 'Lattung' },
            output: '24',
            value: 'ba-24'
            },
            {
                type: 'suspendedCeiling',
                title: { de: 'Gipsplatte GKFI' },
                output: '12,5',
                value: 'g-12.5'
              }
        ],
        sum: {
            output: '471', value: 471
        }
        },
        technicalValues: {
        impactSoundLevel: { // L,nw
            output: '56 (1; 2)',
            value: 56
        },
        soundReductionIndex: { // Rw
            output: '63 (-4; -11)',
            value: 63
        },
        heatTransferCoefficient: { // U-Wert
            output: '0,16',
            value: 0.16
        },
        fireResistance: {
          output: '-', value: null
        },
        massPerUnitArea: {
          output: '258,2 [kg/m²]'
        }
        }
    },
    image: 'da-hms-004.png',
    pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-4-DA-HMS-004-Rev01.pdf'
    }
  
